import { DomSanitizer} from '@angular/platform-browser'
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'safe'
})
export class SafePipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}
    transform(url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }


// WEBPACK FOOTER //
// ./src/app/services/SafePipe.ts